/* eslint-disable no-shadow */
// eslint-disable-next-line import/prefer-default-export
export enum SortActions {
  SET_TYPE = '[Sort] Set Type',
}
